import dayjs from 'dayjs';
import { NavDataUpdateModeOptions } from '../../../../../types/dropdown-options';
import { MapUpdateMode } from '../../../../../types/settings';
import { DropdownListWithValueField } from '../../../../components/inputs/DropdownListWithValueField';
import MarkerText from '../../../../components/inputs/MarkerText';
import { useAppDispatch, useAppSelector } from '../../../../hooks/store-hooks';
import { useMapSourceSettings } from '../../../../hooks/use-map-settings';
import { setSetting } from '../../../../state/slices/settings-slice';
import { useSearchContext } from '../../context/SettingsSearchContext';

export function SettingsMapUpdateModeElement() {
    const mode = useAppSelector((x) => x.settings.navMapUpdateMode);
    const selectedNavVersion = useAppSelector((x) => x.settings.navMap);
    const mapSettings = useMapSourceSettings();
    const context = useSearchContext();
    const dispatch = useAppDispatch();

    return (
        <div className="d-flex justify-content-between align-items-center px-3">
            <div>
                <MarkerText highlight={context.term}>Navigation data</MarkerText>
            </div>
            <div className="flex-shrink-0 flex-grow-0 d-flex flex-column justify-content-center" style={{ width: 300, minHeight: 55 }}>
                <DropdownListWithValueField
                    data={NavDataUpdateModeOptions}
                    value={mode}
                    onChange={(e) => {
                        dispatch(setSetting('navMapUpdateMode', e.value));
                        if (e.value === MapUpdateMode.manual) {
                            if (!selectedNavVersion) {
                                // Someone choose manual, but they don't have any manually selected version yet
                                dispatch(
                                    setSetting('navMap', {
                                        company: mapSettings.nav.company,
                                        version: mapSettings.nav.version,
                                        sequence: mapSettings.nav.sequence,
                                        cycleDate: dayjs.unix(mapSettings.nav.cycleDate).toISOString(),
                                        buildDate: dayjs.unix(mapSettings.nav.buildDate).toISOString()
                                    })
                                );
                            }
                        }
                    }}
                />
            </div>
        </div>
    );
}
